import { HttpClient } from '../../shared/providers/http/http-client';
import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

export const notificationCenterIcons = [
  {
    icon: 'assets/img/message.svg',
    keys: [
      'homekeeper.chat.message_received',
      'email-verification',
      'email-warning-v1',
      'customer-to-homekeeper-availability-request-initiated'
    ]
  },
  {
    icon: 'assets/img/notifications/job-scheduled.svg',
    keys: [
      'waterfall.homekeeper.ecr_created_for_priority',
      'homekeeper.job_booked'
    ]
  },
  {
    icon: 'assets/img/notifications/invoice-paid.svg',
    keys: [
      'homekeeper.after-customer-sent-private-payment-to-homekeeper',
    ]
  },
  {
    icon: 'assets/img/notifications/alert-notification.svg',
    keys: [
      'homekeeper-account-cancellation-email',
      'homekeeper.guest_reservation_source_has_been_paused'
    ]
  },
  {
    icon: 'assets/img/notifications/question-circle.svg',
    keys: [
      'homekeeper-to-homekeeper-lost-item-flow',
    ]
  },
  {
    icon: 'assets/img/notifications/welcome-notification.svg',
    keys: [
      'homekeeper.referral-code-skip-password', //Ark welcomes you to TIDY!
    ]
  },
  {
    icon: 'assets/img/notifications/cant-find-home-notification.svg',
    keys: [
      'change-performance-cant-find-home-v2',
      'change-performance-no-access-v2'
    ]
  },
  {
    icon: 'assets/img/notifications/integration-removed-notification.svg',
    keys: [
      'homekeeper.guest_reservation_source_deactivated',
    ]
  },
  {
    icon: 'assets/img/notifications/properties-updated-notification.svg',
    keys: [
      'homekeeper.guest_reservation_addresses_were_removed_from_the_source',
      'homekeeper.guest_reservation_addresses_were_updated_in_the_source'
    ]
  },
  {
    icon: 'assets/img/notifications/job-completed.svg',
    keys: [
      'homekeepers.cleaning_certificate',
      'client-cleaning-certificate-v3',
      'homekeeper.completed-cleaning-without-instructions',
      'homekeeper.completed-cleaning'
    ]
  },
  {
    icon: 'assets/img/paper-plane.svg',
    keys: [
      'homekeeper.proposal_was_created',
    ]
  },
  {
    icon: 'assets/img/notifications/user-added.svg',
    keys: [
      'homekeeper.homekeeper_added_you_as_private_client',
    ]
  },
  {
    icon: 'assets/img/notifications/parking-reimbursement-request.svg',
    keys: [
      'homekeepers.cleanings.parking_reimbursement_initiated',
    ]
  },
  {
    icon: 'assets/img/notifications/feedback-followup.svg',
    keys: [
      'feedback-bad-cleaning',
      'feedback-ask-for-more-details',
      'feedback-you-can-book-more-time'
    ]
  },
  {
    icon: 'assets/img/notifications/dispute-lost.svg',
    keys: [
      'homekeepers.disputes.homekeeper_won',
      'homekeepers.disputes.both_lost',
      'dispute.cleaning.homekeeper.lost'
    ]
  },
  {
    icon: 'assets/img/notifications/dispute-won.svg',
    keys: [
      'homekeepers.disputes.client_won',
      'homekeepers.disputes.both_won',
      'dispute.cleaning.homekeeper.won'
    ]
  },
  {
    icon: 'assets/img/notifications/dispute-response.svg',
    keys: [
      'dispute.cleaning.homekeeper.counter_proposal',
    ]
  },
  {
    icon: 'assets/img/notifications/dispute.svg',
    keys: [
      'dispute.cleaning.homekeeper.opened',
    ]
  },
  {
    icon: 'assets/img/notifications/sync-failed.svg',
    keys: [
      'guest-reservation-source-addresses-sync-failed',
    ]
  },
  {
    icon: 'assets/img/notifications/job-rescheduled.svg',
    keys: [
      'homekeepers.cleanings.reschedule_plan',
      'homekeepers.cleanings.reschedule_cleaning',
      'homekeeper-to-homekeeper-availability-request-accepted'
    ]
  },
  {
    icon: 'assets/img/notifications/job-canceled.svg',
    keys: [
      'homekeepers.cleanings.cancel_cleaning',
      'change-performance-client-refuses-service',
      'homekeeper-to-homekeeper-availability-request-rejected',
      'homekeeper.job_cancellation'
    ]
  },
  {
    icon: 'assets/img/search.svg',
    keys: [
      'homekeeper.job_request_created',
    ]
  },
  {
    icon: 'assets/img/notifications/job-scheduled.svg',
    keys: [
      'homekeepers.cleanings.new_opc',
      'homekeepers.cleanings.first_booking', //this seems redundant to new_opc
      'homekeeper.proposal_was_accepted',
      'homekeeper-cleaning-confirmation-v1'
    ]
  },
  {
    icon: 'assets/img/notifications/job-soon.svg',
    keys: [
      'homekeeper-cleaning-reminder-without-instruction',
      'homekeeper-cleaning-reminder-to-dos-off',
      'private-homekeeper-cleaning-reminders',
      'homekeeper-cleaning-reminder-with-instruction-v2'
    ]
  },
  {
    icon: 'assets/img/invoice.svg',
    keys: [
      'send-homekeeper-invoice-from-homekeeper',
      'homekeeper-to-homekeeper-invoice' // this seems redundant to from-homekeeper
    ]
  },
  {
    icon: 'assets/img/notifications/invoice-paid.svg',
    keys: [
      'homekeeper-to-homekeeper-invoice-auto-paid',
    ]
  },
  {
    icon: 'assets/img/notifications/propose-times.svg',
    keys: [
      'homekeeper-to-homekeeper-availability-request-countered',
    ]
  },
  {
    icon: 'assets/img/notifications/unassigned-success.svg',
    keys: [
      'homekeepers.sa.unassigned_success',
      'homekeepers.sa.unassigned_success.1',
      'homekeepers.sa.unassigned_success.2',
      'homekeepers.sa.unassigned_success.3',
      'homekeepers.sa.unassigned_success.4',
      'homekeepers.sa.unassigned_success.5',
      'homekeepers.sa.unassigned_success.6',
      'homekeepers.sa.unassigned_success.7',
      'homekeepers.sa.unassigned_success.8',
      'homekeepers.sa.unassigned_success.9',
      'homekeepers.sa.unassigned_success.10',
      'homekeepers.sa.unassigned_success.11',
      'homekeepers.sa.unassigned_success.12',
      'homekeepers.sa.unassigned_success.13',
      'homekeepers.sa.unassigned_success.14',
      'homekeepers.sa.unassigned_success.15',
      'homekeepers.sa.unassigned_success.16',
      'homekeepers.sa.unassigned_success.17',
      'homekeepers.sa.unassigned_success.18',
      'homekeepers.sa.unassigned_success.19',
      'homekeepers.sa.unassigned_success.20',
      'homekeepers.sa.unassigned_success.21',
      'homekeepers.sa.unassigned_success.22',
      'homekeepers.sa.unassigned_success.23',
      'homekeepers.sa.unassigned_success.24',
      'homekeepers.sa.unassigned_success.25',
      'homekeepers.sa.unassigned_success.26',
      'homekeepers.sa.unassigned_success.27',
      'homekeepers.sa.unassigned_success.28',
      'homekeepers.sa.unassigned_success.29',
      'homekeepers.sa.unassigned_success.30',
      'homekeepers.sa.unassigned_success.31',
      'homekeepers.sa.unassigned_success.32',
      'homekeepers.sa.unassigned_success.33',
      'homekeepers.sa.unassigned_success.34',
      'homekeepers.sa.unassigned_success.35',
      'homekeepers.sa.unassigned_success.36'
    ]
  },
  {
    icon: 'assets/img/notifications/unassigned.svg',
    keys: [
      'homekeepers.sa.unassigned',
      'homekeepers.sa.unassigned.2',
      'homekeepers.sa.unassigned.4',
      'homekeepers.sa.unassigned.6',
      'homekeepers.sa.unassigned.8',
      'homekeepers.sa.unassigned.10',
      'homekeepers.sa.unassigned.12',
      'homekeepers.sa.unassigned.14',
      'homekeepers.sa.unassigned.16',
      'homekeepers.sa.unassigned.18',
      'homekeepers.sa.unassigned.20',
      'homekeepers.sa.unassigned.22',
      'homekeepers.sa.unassigned.25',
      'homekeepers.sa.unassigned.28',
      'homekeepers.sa.unassigned.31',
      'homekeepers.sa.unassigned.34',
      'homekeepers.sa.unassigned.37',
      'homekeepers.sa.unassigned.40',
      'homekeepers.sa.unassigned.43',
      'homekeepers.sa.unassigned.46',
      'homekeepers.sa.unassigned.49',
      'homekeepers.sa.unassigned.51',
      'homekeepers.sa.unassigned.52',
      'homekeepers.sa.unassigned.54',
      'homekeepers.sa.unassigned.57',
      'homekeepers.sa.unassigned.60',
      'homekeepers.sa.unassigned.63',
      'homekeepers.sa.unassigned.66',
      'homekeepers.sa.unassigned.69',
      'homekeepers.sa.unassigned.72',
      'homekeepers.sa.unassigned.75',
      'homekeepers.sa.unassigned.77',
      'homekeepers.sa.unassigned.78',
      'homekeepers.sa.unassigned.80',
      'homekeepers.sa.unassigned.82',
      'homekeepers.sa.unassigned.84',
      'homekeepers.sa.unassigned.86',
      'homekeepers.sa.unassigned.88',
      'homekeepers.sa.unassigned.90',
      'homekeepers.sa.unassigned.92',
      'homekeepers.sa.unassigned.94',
      'homekeepers.sa.unassigned.95',
      'homekeepers.sa.unassigned.96',
      'homekeepers.sa.unassigned.29',
      'homekeepers.sa.unassigned.32',
      'homekeepers.sa.unassigned.35',
      'homekeepers.sa.unassigned.38',
      'homekeepers.sa.unassigned.41',
      'homekeepers.sa.unassigned.44',
      'homekeepers.sa.unassigned.55',
      'homekeepers.sa.unassigned.58',
      'homekeepers.sa.unassigned.61',
      'homekeepers.sa.unassigned.64',
      'homekeepers.sa.unassigned.67',
      'homekeepers.sa.unassigned.70',
      'homekeepers.sa.unassigned.',
      'homekeepers.sa.unassigned.23',
      'homekeepers.sa.unassigned.139',
      'homekeepers.sa.unassigned.140',
      'homekeepers.sa.unassigned.26',
      'homekeepers.sa.unassigned.98',
      'homekeepers.sa.unassigned.99',
      'homekeepers.sa.unassigned.100',
      'homekeepers.sa.unassigned.101',
      'homekeepers.sa.unassigned.102',
      'homekeepers.sa.unassigned.103',
      'homekeepers.sa.unassigned.104',
      'homekeepers.sa.unassigned.105',
      'homekeepers.sa.unassigned.106',
      'homekeepers.sa.unassigned.107',
      'homekeepers.sa.unassigned.108',
      'homekeepers.sa.unassigned.109',
      'homekeepers.sa.unassigned.110',
      'homekeepers.sa.unassigned.111',
      'homekeepers.sa.unassigned.112',
      'homekeepers.sa.unassigned.113',
      'homekeepers.sa.unassigned.114',
      'homekeepers.sa.unassigned.115',
      'homekeepers.sa.unassigned.116',
      'homekeepers.sa.unassigned.117',
      'homekeepers.sa.unassigned.118',
      'homekeepers.sa.unassigned.119',
      'homekeepers.sa.unassigned.120',
      'homekeepers.sa.unassigned.121',
      'homekeepers.sa.unassigned.122',
      'homekeepers.sa.unassigned.123',
      'homekeepers.sa.unassigned.124',
      'homekeepers.sa.unassigned.125',
      'homekeepers.sa.unassigned.126',
      'homekeepers.sa.unassigned.127',
      'homekeepers.sa.unassigned.128',
      'homekeepers.sa.unassigned.129',
      'homekeepers.sa.unassigned.130',
      'homekeepers.sa.unassigned.131',
      'homekeepers.sa.unassigned.132',
      'homekeepers.sa.unassigned.133',
      'homekeepers.sa.unassigned.134',
      'homekeepers.sa.unassigned.135',
      'homekeepers.sa.unassigned.136',
      'homekeepers.sa.unassigned.137',
      'homekeepers.sa.unassigned.138'
    ]
  }
]

export const examplesData = [
  {
    notification_key: 'homekeeper-to-homekeeper-invoice-auto-paid',
    notification_title: 'Homekeeper To homekeeper Invoice Auto Paid',
    email_template_subject: 'Invoice from {{{team_name}}} was paid'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.2',
    notification_title: 'homekeepers.Sa.Unassigned.2',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.4',
    notification_title: 'homekeepers.Sa.Unassigned.4',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.6',
    notification_title: 'homekeepers.Sa.Unassigned.6',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.8',
    notification_title: 'homekeepers.Sa.Unassigned.8',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.10',
    notification_title: 'homekeepers.Sa.Unassigned.10',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.12',
    notification_title: 'homekeepers.Sa.Unassigned.12',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.14',
    notification_title: 'homekeepers.Sa.Unassigned.14',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.16',
    notification_title: 'homekeepers.Sa.Unassigned.16',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.18',
    notification_title: 'homekeepers.Sa.Unassigned.18',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.20',
    notification_title: 'homekeepers.Sa.Unassigned.20',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.22',
    notification_title: 'homekeepers.Sa.Unassigned.22',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.25',
    notification_title: 'homekeepers.Sa.Unassigned.25',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.28',
    notification_title: 'homekeepers.Sa.Unassigned.28',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.31',
    notification_title: 'homekeepers.Sa.Unassigned.31',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.34',
    notification_title: 'homekeepers.Sa.Unassigned.34',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.37',
    notification_title: 'homekeepers.Sa.Unassigned.37',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.40',
    notification_title: 'homekeepers.Sa.Unassigned.40',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.43',
    notification_title: 'homekeepers.Sa.Unassigned.43',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.46',
    notification_title: 'homekeepers.Sa.Unassigned.46',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.49',
    notification_title: 'homekeepers.Sa.Unassigned.49',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.51',
    notification_title: 'homekeepers.Sa.Unassigned.51',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.52',
    notification_title: 'homekeepers.Sa.Unassigned.52',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.54',
    notification_title: 'homekeepers.Sa.Unassigned.54',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.57',
    notification_title: 'homekeepers.Sa.Unassigned.57',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.60',
    notification_title: 'homekeepers.Sa.Unassigned.60',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.63',
    notification_title: 'homekeepers.Sa.Unassigned.63',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.66',
    notification_title: 'homekeepers.Sa.Unassigned.66',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.69',
    notification_title: 'homekeepers.Sa.Unassigned.69',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.72',
    notification_title: 'homekeepers.Sa.Unassigned.72',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.75',
    notification_title: 'homekeepers.Sa.Unassigned.75',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.77',
    notification_title: 'homekeepers.Sa.Unassigned.77',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.78',
    notification_title: 'homekeepers.Sa.Unassigned.78',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.80',
    notification_title: 'homekeepers.Sa.Unassigned.80',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.82',
    notification_title: 'homekeepers.Sa.Unassigned.82',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.84',
    notification_title: 'homekeepers.Sa.Unassigned.84',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.86',
    notification_title: 'homekeepers.Sa.Unassigned.86',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.88',
    notification_title: 'homekeepers.Sa.Unassigned.88',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.90',
    notification_title: 'homekeepers.Sa.Unassigned.90',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.92',
    notification_title: 'homekeepers.Sa.Unassigned.92',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.94',
    notification_title: 'homekeepers.Sa.Unassigned.94',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.95',
    notification_title: 'homekeepers.Sa.Unassigned.95',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.96',
    notification_title: 'homekeepers.Sa.Unassigned.96',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.29',
    notification_title: 'homekeepers.Sa.Unassigned.29',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.32',
    notification_title: 'homekeepers.Sa.Unassigned.32',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.35',
    notification_title: 'homekeepers.Sa.Unassigned.35',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.38',
    notification_title: 'homekeepers.Sa.Unassigned.38',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.41',
    notification_title: 'homekeepers.Sa.Unassigned.41',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.44',
    notification_title: 'homekeepers.Sa.Unassigned.44',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.55',
    notification_title: 'homekeepers.Sa.Unassigned.55',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.58',
    notification_title: 'homekeepers.Sa.Unassigned.58',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.61',
    notification_title: 'homekeepers.Sa.Unassigned.61',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.64',
    notification_title: 'homekeepers.Sa.Unassigned.64',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.67',
    notification_title: 'homekeepers.Sa.Unassigned.67',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.70',
    notification_title: 'homekeepers.Sa.Unassigned.70',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.',
    notification_title: 'homekeepers.Sa.Unassigned.',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.cleanings.new_opc',
    notification_title: 'homekeepers.Cleanings.New Opc',
    email_template_subject: 'TIDY Confirmation: You have scheduled a new cleaning'
  },
  {
    notification_key: 'homekeepers.payments.payout_failed',
    notification_title: 'Payout Failed',
    email_template_subject: 'Bank information needed'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.23',
    notification_title: 'homekeepers.Sa.Unassigned.23',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-availability-request-accepted',
    notification_title: 'Homekeeper To homekeeper Availability Request Accepted',
    email_template_subject: 'Your pro {{{homekeeper.first_name}}} has successfully been rescheduled'
  },
  {
    notification_key: 'homekeeper.job_request_created',
    notification_title: 'homekeeper.Job Request Created',
    email_template_subject: 'New job request'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.139',
    notification_title: 'homekeepers.Sa.Unassigned.139',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.140',
    notification_title: 'homekeepers.Sa.Unassigned.140',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeeper.job_cancellation',
    notification_title: 'Job Cancelled',
    email_template_subject: 'Job Cancelled'
  },
  {
    notification_key: 'guest-reservation-source-addresses-sync-failed',
    notification_title: 'Guest Reservation Source Addresses Sync Failed',
    email_template_subject: 'Listing not synced'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.26',
    notification_title: 'homekeepers.Sa.Unassigned.26',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.cleanings.first_booking',
    notification_title: 'homekeepers.Cleanings.First Booking',
    email_template_subject: 'TIDY Confirmation: You have scheduled {{{words.pluralization.cleaning}}}'
  },
  {
    notification_key: 'homekeepers.disputes.new_dispute',
    notification_title: 'New Dispute',
    email_template_subject: 'Client Disputed a Cleaning'
  },
  {
    notification_key: 'homekeepers.disputes.homekeeper_won',
    notification_title: 'You Won a Dispute',
    email_template_subject: 'Client dispute found in your favor'
  },
  {
    notification_key: 'homekeepers.disputes.both_won',
    notification_title: 'Homekeepers.Disputes.Both Won',
    email_template_subject: 'Client dispute found in your favor'
  },
  {
    notification_key: 'homekeepers.disputes.client_won',
    notification_title: 'Homekeepers.Disputes.Client Won',
    email_template_subject: 'Client dispute not found in your favor'
  },
  {
    notification_key: 'homekeepers.disputes.both_lost',
    notification_title: 'Homekeepers.Disputes.Both Lost',
    email_template_subject: 'Client dispute not found in your favor'
  },
  {
    notification_key: 'homekeepers.disputes.client_won',
    notification_title: 'homekeepers.Disputes.Client Won',
    email_template_subject: 'Dispute found in your favor'
  },
  {
    notification_key: 'homekeepers.disputes.both_won',
    notification_title: 'homekeepers.Disputes.Both Won',
    email_template_subject: 'Dispute found in your favor'
  },
  {
    notification_key: 'homekeepers.disputes.homekeeper_won',
    notification_title: 'homekeepers.Disputes.Homekeeper Won',
    email_template_subject: 'Dispute not found in your favor'
  },
  {
    notification_key: 'homekeepers.disputes.both_lost',
    notification_title: 'homekeepers.Disputes.Both Lost',
    email_template_subject: 'Dispute not found in your favor'
  },
  {
    notification_key: 'homekeepers.cleanings.reschedule_plan',
    notification_title: 'homekeepers.Cleanings.Reschedule Plan',
    email_template_subject: 'TIDY Confirmation: You have rescheduled {{{words.pluralization.cleaning}}}'
  },
  {
    notification_key: 'homekeepers.cleanings.reschedule_cleaning',
    notification_title: 'homekeepers.Cleanings.Reschedule Cleaning',
    email_template_subject: 'TIDY Confirmation: You have rescheduled a cleaning'
  },
  {
    notification_key: 'homekeepers.cleanings.cancel_cleaning',
    notification_title: 'homekeepers.Cleanings.Cancel Cleaning',
    email_template_subject: 'TIDY Confirmation: You cancelled a cleaning'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-lost-item-flow',
    notification_title: 'homekeeper To Homekeeper Lost Item Flow',
    email_template_subject: 'Client {{{homekeeper.first_name}}} is reaching out about a missing item'
  },
  {
    notification_key: 'feedback-bad-cleaning',
    notification_title: 'Feedback Bad Cleaning',
    email_template_subject: 'Following up on your negative review'
  },
  {
    notification_key: 'feedback-ask-for-more-details',
    notification_title: 'Feedback Ask For More Details',
    email_template_subject: 'Following up on your negative review'
  },
  {
    notification_key: 'feedback-you-can-book-more-time',
    notification_title: 'Feedback You Can Book More Time',
    email_template_subject: 'Following up on your negative review'
  },
  {
    notification_key: 'homekeeper-account-cancellation-email',
    notification_title: 'homekeeper Account Cancellation Email',
    email_template_subject: 'TIDY Account Cancellation Confirmation'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-availability-request-countered',
    notification_title: 'homekeeper To Homekeeper Availability Request Countered',
    email_template_subject: 'Client {{{homekeeper.display_name}}} proposed different times to reschedule'
  },
  {
    notification_key: 'homekeeper-email-verification-v1',
    notification_title: 'Homekeeper Email Verification V1',
    email_template_subject: 'TIDY Email Confirmation'
  },
  {
    notification_key: 'homekeepers.cleanings.parking_reimbursement_approved',
    notification_title: 'Parking Reimbursement Approved',
    email_template_subject: 'Your parking reimbursement request was approved'
  },
  {
    notification_key: 'homekeepers.cleanings.parking_reimbursement_rejected',
    notification_title: 'Parking Reimbursement Rejected',
    email_template_subject: 'Your parking reimbursement request was rejected'
  },
  {
    notification_key: 'email-warning-v1',
    notification_title: 'Email Warning V1',
    email_template_subject: 'TIDY Email Change to {{{new_email}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.98',
    notification_title: 'homekeepers.Sa.Unassigned.98',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.99',
    notification_title: 'homekeepers.Sa.Unassigned.99',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.100',
    notification_title: 'homekeepers.Sa.Unassigned.100',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.101',
    notification_title: 'homekeepers.Sa.Unassigned.101',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.102',
    notification_title: 'homekeepers.Sa.Unassigned.102',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.103',
    notification_title: 'homekeepers.Sa.Unassigned.103',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.104',
    notification_title: 'homekeepers.Sa.Unassigned.104',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.105',
    notification_title: 'homekeepers.Sa.Unassigned.105',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.106',
    notification_title: 'homekeepers.Sa.Unassigned.106',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.107',
    notification_title: 'homekeepers.Sa.Unassigned.107',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.108',
    notification_title: 'homekeepers.Sa.Unassigned.108',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.109',
    notification_title: 'homekeepers.Sa.Unassigned.109',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.110',
    notification_title: 'homekeepers.Sa.Unassigned.110',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.111',
    notification_title: 'homekeepers.Sa.Unassigned.111',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.112',
    notification_title: 'homekeepers.Sa.Unassigned.112',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.113',
    notification_title: 'homekeepers.Sa.Unassigned.113',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.114',
    notification_title: 'homekeepers.Sa.Unassigned.114',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.115',
    notification_title: 'homekeepers.Sa.Unassigned.115',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.116',
    notification_title: 'homekeepers.Sa.Unassigned.116',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.117',
    notification_title: 'homekeepers.Sa.Unassigned.117',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.118',
    notification_title: 'homekeepers.Sa.Unassigned.118',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeeper.homekeeper_added_you_on_tidy_and_in_your_list',
    notification_title: 'homekeeper Added You',
    email_template_subject: 'The Client {{homekeeper_name}} added you on TIDY'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-lost-item-flow',
    notification_title: 'Homekeeper To homekeeper Lost Item Flow',
    email_template_subject: 'Your pro {{{homekeeper.first_name}}} is reaching out about a missing item'
  },
  {
    notification_key: 'homekeepers.cleanings.parking_reimbursement_initiated',
    notification_title: 'homekeepers.Cleanings.Parking Reimbursement Initiated',
    email_template_subject: 'Your pro has a parking reimbursement request'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-availability-request-countered',
    notification_title: 'Homekeeper To homekeeper Availability Request Countered',
    email_template_subject: 'Your pro {{{homekeeper.first_name}}} proposed different times to reschedule'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-availability-request-rejected',
    notification_title: 'Homekeeper To homekeeper Availability Request Rejected',
    email_template_subject: 'Your pro {{{homekeeper.first_name}}} could not reschedule'
  },
  {
    notification_key: 'email-resubmit-hk-equipment-v1',
    notification_title: 'Email Resubmit Hk Equipment V1',
    email_template_subject: 'Could Not Certify Equipment'
  },
  {
    notification_key: 'homekeepers.job_delegation_requests.accept_request',
    notification_title: 'Job Delegation Requests',
    email_template_subject: '{{{name_new_homekeeper}}} accepted your cleaning delegation'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.119',
    notification_title: 'homekeepers.Sa.Unassigned.119',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.120',
    notification_title: 'homekeepers.Sa.Unassigned.120',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.121',
    notification_title: 'homekeepers.Sa.Unassigned.121',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.122',
    notification_title: 'homekeepers.Sa.Unassigned.122',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.123',
    notification_title: 'homekeepers.Sa.Unassigned.123',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.124',
    notification_title: 'homekeepers.Sa.Unassigned.124',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.125',
    notification_title: 'homekeepers.Sa.Unassigned.125',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.1',
    notification_title: 'homekeepers.Sa.Unassigned Success.1',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.2',
    notification_title: 'homekeepers.Sa.Unassigned Success.2',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.3',
    notification_title: 'homekeepers.Sa.Unassigned Success.3',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.4',
    notification_title: 'homekeepers.Sa.Unassigned Success.4',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.5',
    notification_title: 'homekeepers.Sa.Unassigned Success.5',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.6',
    notification_title: 'homekeepers.Sa.Unassigned Success.6',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.7',
    notification_title: 'homekeepers.Sa.Unassigned Success.7',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.8',
    notification_title: 'homekeepers.Sa.Unassigned Success.8',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.9',
    notification_title: 'homekeepers.Sa.Unassigned Success.9',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.10',
    notification_title: 'homekeepers.Sa.Unassigned Success.10',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.11',
    notification_title: 'homekeepers.Sa.Unassigned Success.11',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.12',
    notification_title: 'homekeepers.Sa.Unassigned Success.12',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.13',
    notification_title: 'homekeepers.Sa.Unassigned Success.13',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.14',
    notification_title: 'homekeepers.Sa.Unassigned Success.14',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.15',
    notification_title: 'homekeepers.Sa.Unassigned Success.15',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.16',
    notification_title: 'homekeepers.Sa.Unassigned Success.16',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.17',
    notification_title: 'homekeepers.Sa.Unassigned Success.17',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.18',
    notification_title: 'homekeepers.Sa.Unassigned Success.18',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.19',
    notification_title: 'homekeepers.Sa.Unassigned Success.19',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.20',
    notification_title: 'homekeepers.Sa.Unassigned Success.20',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.21',
    notification_title: 'homekeepers.Sa.Unassigned Success.21',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.22',
    notification_title: 'homekeepers.Sa.Unassigned Success.22',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.23',
    notification_title: 'homekeepers.Sa.Unassigned Success.23',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.24',
    notification_title: 'homekeepers.Sa.Unassigned Success.24',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeeper.team.member.invitation',
    notification_title: 'Homekeeper.Team.Member.Invitation',
    email_template_subject: '{{{team_owner_first_name}}} has invited you to their team: {{{team_name}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.126',
    notification_title: 'homekeepers.Sa.Unassigned.126',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.127',
    notification_title: 'homekeepers.Sa.Unassigned.127',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.128',
    notification_title: 'homekeepers.Sa.Unassigned.128',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.129',
    notification_title: 'homekeepers.Sa.Unassigned.129',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.130',
    notification_title: 'homekeepers.Sa.Unassigned.130',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.131',
    notification_title: 'homekeepers.Sa.Unassigned.131',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.132',
    notification_title: 'homekeepers.Sa.Unassigned.132',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.133',
    notification_title: 'homekeepers.Sa.Unassigned.133',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.134',
    notification_title: 'homekeepers.Sa.Unassigned.134',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.135',
    notification_title: 'homekeepers.Sa.Unassigned.135',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.136',
    notification_title: 'homekeepers.Sa.Unassigned.136',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.137',
    notification_title: 'homekeepers.Sa.Unassigned.137',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.25',
    notification_title: 'homekeepers.Sa.Unassigned Success.25',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.26',
    notification_title: 'homekeepers.Sa.Unassigned Success.26',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.27',
    notification_title: 'homekeepers.Sa.Unassigned Success.27',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.28',
    notification_title: 'homekeepers.Sa.Unassigned Success.28',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.29',
    notification_title: 'homekeepers.Sa.Unassigned Success.29',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.30',
    notification_title: 'homekeepers.Sa.Unassigned Success.30',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.31',
    notification_title: 'homekeepers.Sa.Unassigned Success.31',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.32',
    notification_title: 'homekeepers.Sa.Unassigned Success.32',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.33',
    notification_title: 'homekeepers.Sa.Unassigned Success.33',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.34',
    notification_title: 'homekeepers.Sa.Unassigned Success.34',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.35',
    notification_title: 'homekeepers.Sa.Unassigned Success.35',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned_success.36',
    notification_title: 'homekeepers.Sa.Unassigned Success.36',
    email_template_subject: '{{{subject}}}'
  },
  {
    notification_key: 'email-verification-v1',
    notification_title: 'Email Verification V1',
    email_template_subject: 'Email Verification'
  },
  {
    notification_key: 'homekeeper.tidy_added_you_on_job_by_vendor_outreach_request',
    notification_title: 'Homekeeper.Tidy Added You On Job By Vendor Outreach Request',
    email_template_subject: 'We have a job for you!'
  },
  {
    notification_key: 'homekeeper.proposal_was_accepted',
    notification_title: 'homekeeper.Proposal Was Accepted',
    email_template_subject: 'Your Accepted {{service_type_name}} Proposal'
  },
  {
    notification_key: 'homekeeper.proposal_was_accepted',
    notification_title: 'Proposal Was Accepted',
    email_template_subject: 'Your proposal with {{homekeeper_full_name}} was accepted'
  },
  {
    notification_key: 'homekeeper.homekeeper_added_you_as_private_client',
    notification_title: 'homekeeper.Homekeeper Added You As Private Client',
    email_template_subject: 'The pro {{homekeeper_name}} added you'
  },
  {
    notification_key: 'homekeeper.homekeeper_added_you_on_private_list',
    notification_title: 'Homekeeper.homekeeper Added You On Private List',
    email_template_subject: 'Your client {{homekeeper_name}} added you to their favorites in TIDY'
  },
  {
    notification_key: 'homekeepers.job_delegation_requests.reject_request',
    notification_title: 'Job Delegation Request Rejected',
    email_template_subject: '{{{name_new_homekeeper}}} rejected your job delegation'
  },
  {
    notification_key: 'homekeeper.proposal_was_created',
    notification_title: 'homekeeper.Proposal Was Created',
    email_template_subject: 'You received a Proposal for {{service_type_name}}'
  },
  {
    notification_key: 'background-check-approved-v1',
    notification_title: 'Background Check Approved V1',
    email_template_subject: 'Your background check was approved.'
  },
  {
    notification_key: 'homekeepers.cleaning_certificate',
    notification_title: 'homekeepers.Cleaning Certificate',
    email_template_subject: '{{email_subject}}'
  },
  {
    notification_key: 'homekeepers.sa.unassigned.138',
    notification_title: 'homekeepers.Sa.Unassigned.138',
    email_template_subject: '{{{email_subject}}}'
  },
  {
    notification_key: 'send-homekeeper-invoice-from-homekeeper',
    notification_title: 'Send homekeeper Invoice From Homekeeper',
    email_template_subject: 'Invoice from {{team_name}}'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-invoice',
    notification_title: 'Homekeeper To homekeeper Invoice',
    email_template_subject: 'Invoice from {{{team_name}}}'
  },
  {
    notification_key: 'dispute.cleaning.homekeeper.opened',
    notification_title: 'Dispute.Cleaning.homekeeper.Opened',
    email_template_subject: 'Dispute Opened'
  },
  {
    notification_key: 'dispute.cleaning.homekeeper.counter_proposal',
    notification_title: 'Dispute.Cleaning.homekeeper.Counter Proposal',
    email_template_subject: 'Dispute Response (Time Sensitive)'
  },
  {
    notification_key: 'dispute.cleaning.homekeeper.won',
    notification_title: 'Dispute.Cleaning.homekeeper.Won',
    email_template_subject: 'Dispute Won'
  },
  {
    notification_key: 'dispute.cleaning.homekeeper.lost',
    notification_title: 'Dispute.Cleaning.homekeeper.Lost',
    email_template_subject: 'Dispute Resolved'
  },
  {
    notification_key: 'dispute.cleaning.homekeeper.opened',
    notification_title: 'Dispute.Cleaning.Homekeeper.Opened',
    email_template_subject: 'Dispute Opened (Time Sensitive)'
  },
  {
    notification_key: 'dispute.cleaning.homekeeper.counter_proposal',
    notification_title: 'Dispute.Cleaning.Homekeeper.Counter Proposal',
    email_template_subject: 'Dispute Response Sent'
  },
  {
    notification_key: 'dispute.cleaning.homekeeper.won',
    notification_title: 'Dispute.Cleaning.Homekeeper.Won',
    email_template_subject: 'Dispute Won'
  },
  {
    notification_key: 'homekeeper.opportunities_summary',
    notification_title: 'Open Job Opportunities Summary',
    email_template_subject: '{{opportunities_count}} jobs match your settings {{full_date_formatted}}.'
  },
  {
    notification_key: 'homekeeper.guest_reservation_addresses_were_removed_from_the_source',
    notification_title: 'homekeeper.Guest Reservation Addresses Were Removed From The Source',
    email_template_subject: '{{amount_addresses_removed}} {{#is_one_address}}property{{/is_one_address}}{{^is_one_address}}properties{{/is_one_address}} removed from {{source_name}}'
  },
  {
    notification_key: 'client-cleaning-certificate-v3',
    notification_title: 'Client Cleaning Certificate V3',
    email_template_subject: 'Cleaning Certificate for your {{job_type}} today'
  },
  {
    notification_key: 'homekeeper.guest_reservation_addresses_were_updated_in_the_source',
    notification_title: 'homekeeper.Guest Reservation Addresses Were Updated In The Source',
    email_template_subject: '{{amount_addresses_removed}} {{#is_one_address}}property{{/is_one_address}}{{^is_one_address}}properties{{/is_one_address}} updated in {{source_name}}'
  },
  {
    notification_key: 'homekeeper.after-homekeeper-sent-private-payment-to-homekeeper',
    notification_title: 'Payment Sent',
    email_template_subject: '${{job_amount}} payment received from {{homekeeper_name}}'
  },
  {
    notification_key: 'homekeeper.guest_reservation_source_has_been_paused',
    notification_title: 'homekeeper.Guest Reservation Source Has Been Paused',
    email_template_subject: 'Your {{integration_name}} integration with TIDY had an error'
  },
  {
    notification_key: 'homekeeper.guest_reservation_source_deactivated',
    notification_title: 'homekeeper.Guest Reservation Source Deactivated',
    email_template_subject: 'You\'ve successfully removed an integration from TIDY'
  },
  {
    notification_key: 'change-performance-cant-find-home-v2',
    notification_title: 'Change Performance Cant Find Home V2',
    email_template_subject: 'Your {{homekeeper.homekeeper_type}} Is Having Trouble Finding your {{homekeeper.home_type}} {{ENV_INFO}}'
  },
  {
    notification_key: 'change-performance-client-refuses-service',
    notification_title: 'Change Performance Client Refuses Service',
    email_template_subject: 'Your {{homekeeper.homekeeper_type}} Reported That You Cancelled Your Cleaning'
  },
  {
    notification_key: 'change-performance-no-access-v2',
    notification_title: 'Change Performance No Access V2',
    email_template_subject: 'Your {{homekeeper.homekeeper_type}} Is Having Trouble Accessing Your {{homekeeper.home_type}} {{ENV_INFO}}'
  },
  {
    notification_key: 'homekeeper-cleaning-confirmation-v1',
    notification_title: 'homekeeper Cleaning Confirmation V1',
    email_template_subject: 'Cleaning Confirmation'
  },
  {
    notification_key: 'waterfall.homekeeper.ecr_created_for_priority',
    notification_title: 'New Opportunity from Past Client',
    email_template_subject: 'New opportunity for you!'
  },
  {
    notification_key: 'dispute.cleaning.homekeeper.lost',
    notification_title: 'Dispute.Cleaning.Homekeeper.Lost',
    email_template_subject: 'Dispute Lost'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-availability-request-initiated-no-job',
    notification_title: 'homekeeper To Homekeeper Availability Request Initiated No Job',
    email_template_subject: 'Your Client {{{homekeeper.display_name}}} requested you!'
  },
  {
    notification_key: 'email-approved-hk-equipment-review-v1',
    notification_title: 'Email Approved Hk Equipment Review V1',
    email_template_subject: 'Equipment Certified'
  },
  {
    notification_key: 'homekeeper.job_booked',
    notification_title: 'Job Booked',
    email_template_subject: 'Client booked you through TIDY: {{job_full_date_time}}'
  },
  {
    notification_key: 'homekeeper.referral-code-skip-password',
    notification_title: 'homekeeper.Referral Code Skip Password',
    email_template_subject: 'Ark welcomes you to TIDY!'
  },
  {
    notification_key: 'hk-in-collections',
    notification_title: 'Hk In Collections',
    email_template_subject: 'You are no longer eligible for equipment'
  },
  {
    notification_key: 'homekeeper-no-show-v1',
    notification_title: 'Homekeeper No Show V1',
    email_template_subject: 'Your {{datetime}} cleaning was updated'
  },
  {
    notification_key: 'homekeeper-cleaning-reminder-without-instruction',
    notification_title: 'homekeeper Cleaning Reminder Without Instruction',
    email_template_subject: 'Friendly Reminder - Your {{job.service_type_name}} is {{job.dow}}, {{job.date}} at {{job.time}}'
  },
  {
    notification_key: 'homekeeper-cleaning-reminder-to-dos-off',
    notification_title: 'homekeeper Cleaning Reminder To Dos Off',
    email_template_subject: 'Friendly Reminder - Your {{job.service_type_name}} is {{job.dow}}, {{job.date}} at {{job.time}}'
  },
  {
    notification_key: 'homekeeper-tomorrow-cleanings-v2',
    notification_title: 'Tomorrow\'s Cleanings Reminder',
    email_template_subject: 'Your Scheduled Cleanings on {{on_date}}'
  },
  {
    notification_key: 'hk-incompleted-cleaning',
    notification_title: 'Hk Incompleted Cleaning',
    email_template_subject: 'Note about a job today'
  },
  {
    notification_key: 'private-homekeeper-cleaning-reminders',
    notification_title: 'Private homekeeper Cleaning Reminders',
    email_template_subject: 'Friendly Reminder - Your {{job.service_type_name}} is {{job.dow}}, {{job.date}} at {{job.time}}'
  },
  {
    notification_key: 'homekeeper-cleaning-reminder-with-instruction-v2',
    notification_title: 'homekeeper Cleaning Reminder With Instruction V2',
    email_template_subject: 'Friendly Reminder - Your {{job.service_type_name}} is {{job.dow}}, {{job.date}} at {{job.time}}'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-availability-request-accepted',
    notification_title: 'homekeeper To Homekeeper Availability Request Accepted',
    email_template_subject: 'Client {{{homekeeper.display_name}}} has successfully been rescheduled'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-availability-request-initiated',
    notification_title: 'homekeeper To Homekeeper Availability Request Initiated',
    email_template_subject: 'Your Client {{{homekeeper.display_name}}} requested you!'
  },
  {
    notification_key: 'homekeeper-to-homekeeper-availability-request-rejected',
    notification_title: 'homekeeper To Homekeeper Availability Request Rejected',
    email_template_subject: 'Client {{{homekeeper.display_name}}} could not reschedule'
  },
  {
    notification_key: 'homekeepers.job_delegation_requests.new_request',
    notification_title: 'Job Delegation Requests',
    email_template_subject: 'New job delegation from {{{name_original_homekeeper}}}'
  },
  {
    notification_key: 'homekeepers.job_delegation_requests.new_request_force_accept',
    notification_title: 'Homekeepers.Job Delegation Requests.New Request Force Accept',
    email_template_subject: 'New job delegation from {{{name_original_homekeeper}}}'
  },
  {
    notification_key: 'homekeeper.chat.message_received',
    notification_title: 'New Message',
    email_template_subject: 'New message'
  },

]

@Injectable()
export class NotificationsProvider {
  private notificationCount$ = new BehaviorSubject<number>(0);
  constructor(
    private httpClient: HttpClient,
    private storage: TidyStorage
  ) {}

  getNotificationCount() {
    return this.notificationCount$.asObservable();
  }

  setNotificationCount(count: number) {
    this.notificationCount$.next(count);
  }

  async getNotifications(page = 1, perPage = 11) {
    const url = `api/v1/homekeeper/notifications?page=${page}&per_page=${perPage}`;
    const response = await this.httpClient.fullRequest({ url, method: 'GET' });
    //TODO always update the count once we have an endpoint to get accurate notification count for header
    if (perPage == 11) {
      const notReadCount = response.body.filter((notification: any) => !notification.is_read).length;
      await this.storage.save('notificationsCount', notReadCount);
      this.setNotificationCount(notReadCount);
    }
    return {
      body: response.body,
      totalRecords: response.headers.get('X-Total-Records'),
      totalPages: response.headers.get('X-Total-Pages'),
      page: response.headers.get('X-Current-Page')
    };
  }

  getNotification(id: string) {
    const url = `api/v1/homekeeper/notifications/${id}`;
    return this.httpClient.get(url);
  }

  markAsRead(id: string) {
    const url = `api/v1/homekeeper/notifications/${id}/mark-as-read`;
    return this.httpClient.post(url, {});
  }

  markAllAsRead() {
    const url = `api/v1/homekeeper/notifications/mark-all-as-read`;
    return this.httpClient.post(url, {});
  }
}
